import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Gestione from "@/pages/Gestione";
import LasciaRecensione from "@/pages/LasciaRecensione";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import { API } from "@/lib/config";
import Privacy from "@/pages/Privacy";
import { ConsensoBanner } from "@/components/ConsensoBanner";
import { useGoogleTagManager } from "@/lib/gtm";
import { useTracciamentoContatti } from "@/lib/tracking";

axios.defaults.withCredentials = true;

let refreshing = null;
axios.interceptors.response.use((r) => r, async (error) => {
  const cfg = error.config || {};
  const url = cfg.url || "";
  if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
    cfg._retry = true;
    refreshing = refreshing || axios.post(`${API}/auth/refresh`).finally(() => { refreshing = null; });
    try { await refreshing; return axios(cfg); } catch { /* sessione scaduta */ }
  }
  return Promise.reject(error);
});

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/gestione" element={<Gestione />} />
      <Route path="/recensione/:token" element={<LasciaRecensione />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

function App() {
  useGoogleTagManager();
  useTracciamentoContatti("393409114543");
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <ConsensoBanner />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
